var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddPortfolios = function SvgAddPortfolios(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 966.9022216796875 851.9774169921875",
    width: "966.9022216796875px",
    height: "851.9774169921875px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 966.9022216796875,
    height: 851.9774169921875,
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.998464584350586, 0, 0, 15.998464584350586, -29.17240285873413, -90.13324737548828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-/-Wallet",
    stroke: "none",
    strokeWidth: 1,
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3612997,55.082124 L12.5816228,55.082124 C8.65012244,55.082124 5.45127944,51.8270745 5.45127944,47.8265486 L5.45127944,17.795487 L5.45127944,17.3340017 C6.47088599,17.8004174 7.70151363,18.0607425 9.13330156,18.1120187 C16.2320903,18.3644551 50.798133,18.1416011 52.255559,18.1317403 C53.9545746,18.1317403 56.8043453,18.7016944 56.8043453,22.5237399 L56.8043453,32.2662087 L52.5089815,32.2662087 C49.8081089,32.2662087 47.6199977,34.4553059 47.6199977,37.1551925 C47.6199977,39.8560652 49.8081089,42.0451625 52.5089815,42.0451625 L56.8043453,42.0451625 L56.8043453,48.523707 C56.8043453,52.1406479 53.9141453,55.082124 50.3612997,55.082124 M9.32755929,9.45127944 L43.7930218,9.45127944 C45.9308429,9.45127944 47.6702878,11.0595757 47.6702878,13.0376518 L47.6702878,14.707085 C37.7582132,14.7593472 14.7549427,14.8569691 9.25557546,14.6627114 C7.71236051,14.6074909 6.59907637,14.2347527 6.03799694,13.582954 C5.56369254,13.0317353 5.55678998,12.3641593 5.56763686,12.162999 C5.99066511,10.6059789 7.51613062,9.45127944 9.32755929,9.45127944 M60.2556248,32.2671948 L60.2556248,22.5237399 C60.2556248,16.7344651 55.9464559,14.6804608 52.2447121,14.6804608 C52.2082272,14.6804608 51.8118231,14.6834191 51.1215672,14.6873634 L51.1215672,13.0376518 C51.1215672,9.15742765 47.833977,6 43.7930218,6 L9.32755929,6 C5.28660411,6 2,9.15742765 2,13.0376518 L2,47.8265486 C2,53.7302086 6.74698835,58.5334035 12.5816228,58.5334035 L50.3612997,58.5334035 C55.8172794,58.5334035 60.2556248,54.0427959 60.2556248,48.523707 L60.2556248,42.0441764 C61.2200108,42.0382599 62,41.2562986 62,40.2919125 L62,34.0204447 C62,33.0550726 61.2200108,32.2731112 60.2556248,32.2671948",
    id: "wallet",
    fill: "#333333"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.1395397186279297, 2.244537830352783, -2.244537830352783, 2.1395397186279297, 837.2894730567932, -2114.648193359375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 562.5999755859375 646.9000244140625 L 545.5999755859375 629.9000244140625 L 518.7000122070312 656.7000122070312 L 491.8999938964844 629.9000244140625 L 474.8999938964844 646.9000244140625 L 501.70001220703125 673.7999877929688 L 474.8999938964844 700.5999755859375 L 491.8999938964844 717.5999755859375 L 518.7000122070312 690.7999877929688 L 545.5999755859375 717.5999755859375 L 562.5999755859375 700.5999755859375 L 535.7999877929688 673.7999877929688 Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.900000095367432, 0, 0, 4.900000095367432, -2761.3007979393005, 15.989566802978516)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M652,46c27.6,0,50,22.4,50,50s-22.4,50-50,50s-50-22.4-50-50S624.4,46,652,46z",
    style: {
      fill: "rgb(51, 51, 51)",
      fillOpacity: 0,
      strokeOpacity: 1,
      stroke: "#333333",
      strokeWidth: 9
    }
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddPortfolios, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add_portfolios.2b060d1f.svg";
export { ForwardRef as ReactComponent };